import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PitchDeck from "./pages/PitchDeck";
import Resources from "./pages/Resources";
import TechnicalSpecs from "./pages/TechnicalSpecs";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pitch" element={<PitchDeck />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/technical-specs" element={<TechnicalSpecs />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;